import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    Fallback: PropTypes.any,
    onError: PropTypes.func,
  };

  static defaultProps = {
    Fallback: () => null,
    onError: () => null,
  };

  constructor(props) {
    super(props);

    this.state = { hasError: false, errorDetails: null };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const { onError } = this.props;

    this.setState({ errorDetails: error }, () => onError(error));
  }

  render() {
    const { Fallback, children } = this.props;
    const { hasError, errorDetails } = this.state;
    const renderChildren = React.Children.map(children, (child) => {
      return React.cloneElement(child, {
        ...this.props,
      });
    });

    if (hasError) {
      return (
        <React.Suspense
          fallback={
            <div>
              Loading <i className="fa fa-loading fa-spin" />
            </div>
          }
        >
          {errorDetails && <Fallback error={errorDetails} />}
        </React.Suspense>
      );
    }

    return (
      <React.Suspense
        fallback={
          <div>
            Loading <i className="fa fa-loading fa-spin" />
          </div>
        }
      >
        {renderChildren}
      </React.Suspense>
    );
  }
}
